<template>
    <div>
        <v-card v-if="podeValidar" class="pa-4 mb-4" outlined>
            <v-card-title class="text-h6 pa-0 mb-3">
                <v-icon left color="primary">mdi-check-decagram</v-icon>
                {{ $t('ticketSuporteFluxo.validacaoTitulo') }}
            </v-card-title>
            <v-divider class="mb-3"></v-divider>
            <div class="text-body-2 mb-3">{{ $t('ticketSuporteFluxo.validacaoTexto') }}</div>
            <v-text-field
                v-model="motivoRejeicao"
                :label="$t('ticketSuporteFluxo.motivoRejeicao')"
                dense
                outlined
                hide-details
                class="mb-3"
            ></v-text-field>
            <div class="d-flex justify-end">
                <v-btn text color="error" class="mr-2" :loading="salvando" :disabled="!motivoRejeicao" @click="validar(false)">
                    {{ $t('ticketSuporteFluxo.rejeitar') }}
                </v-btn>
                <v-btn color="primary" :loading="salvando" @click="validar(true)">
                    {{ $t('ticketSuporteFluxo.validar') }}
                </v-btn>
            </div>
        </v-card>

        <v-card v-if="ultimoEncaminhamento || podeEncaminhar" class="pa-4 mb-4" outlined>
            <v-card-title class="text-h6 pa-0 mb-3">
                <v-icon left color="primary">mdi-email-fast-outline</v-icon>
                {{ $t('ticketSuporteFluxo.encaminhamentoTitulo') }}
            </v-card-title>
            <v-divider class="mb-3"></v-divider>
            <v-alert
                v-if="ultimoEncaminhamento"
                :type="ultimoEncaminhamento.situacao === 'FALHA' ? 'error' : 'info'"
                dense
                outlined
                class="mb-3"
            >
                <div class="font-weight-medium">
                    {{ ultimoEncaminhamento.nome_equipe }}:
                    {{ $t(`ticketSuporteFluxo.situacao.${ultimoEncaminhamento.situacao}`) }}
                </div>
                <div v-if="ultimoEncaminhamento.dt_envio_extenso" class="text-body-2">{{ ultimoEncaminhamento.dt_envio_extenso }}</div>
                <div v-if="ultimoEncaminhamento.situacao === 'FALHA' && ultimoEncaminhamento.ultimo_erro" class="text-body-2">
                    {{ ultimoEncaminhamento.ultimo_erro }}
                </div>
            </v-alert>
            <div v-if="podeEncaminhar" class="d-flex justify-end">
                <v-btn color="primary" :loading="salvando" @click="encaminhar">
                    <v-icon left>mdi-send</v-icon>
                    {{ $t('ticketSuporteFluxo.encaminhar') }}
                </v-btn>
            </div>
        </v-card>
    </div>
</template>

<script>
import apiController from '@/utils/apiController';
import EventBus from '@/utils/eventBus';
import { STATUS_FLUXO } from '@/utils/ticketFluxoSuporte';

const FAMILIA_HARDWARE = 'familia.hardware';
const PREFIXO_CHAVE = 'ticketCatalogo.';

export default {
    name: 'TicketSuporteFluxoCard',
    props: {
        ticket: { type: Object, required: true },
        familias: { type: Array, default: () => [] },
        usuario: { type: Object, default: null },
        somenteLeitura: { type: Boolean, default: false }
    },
    data() {
        return { encaminhamentos: [], motivoRejeicao: '', salvando: false };
    },
    computed: {
        chaveStatus() {
            return String(this.ticket.status_dispatcher_chave || '').replace(PREFIXO_CHAVE, '');
        },
        ehSolicitante() {
            return !!this.usuario && Number(this.ticket.id_usuario_inclusao) === Number(this.usuario.id_usuario);
        },
        podeValidar() {
            return this.ehSolicitante && this.chaveStatus === STATUS_FLUXO.EM_TESTE;
        },
        ultimoEncaminhamento() {
            return this.encaminhamentos[0] || null;
        },
        ehHardware() {
            const familia = this.familias.find((f) => Number(f.id_familia_atendimento) === Number(this.ticket.id_familia_atendimento));
            return !!familia && familia.chave_i18n === FAMILIA_HARDWARE;
        },
        podeEncaminhar() {
            if (this.somenteLeitura || !this.ehHardware) return false;
            if ([STATUS_FLUXO.ABERTO, STATUS_FLUXO.EM_ANDAMENTO].indexOf(this.chaveStatus) < 0) return false;
            return !this.ultimoEncaminhamento || this.ultimoEncaminhamento.situacao === 'FALHA';
        }
    },
    watch: {
        'ticket.id_ticket': { immediate: true, handler: 'carregar' }
    },
    methods: {
        async carregar() {
            this.encaminhamentos = [];
            if (!this.ticket.id_ticket) return;
            try {
                const res = await apiController.request(apiController.endpoints.getEncaminhamentosticket, {
                    params: { id: this.ticket.id_ticket },
                    silent: true
                });
                this.encaminhamentos = Array.isArray(res.data) ? res.data : [];
            } catch (e) {
                this.encaminhamentos = [];
            }
        },
        async executar(endpoint, data) {
            this.salvando = true;
            try {
                const res = await apiController.request(endpoint, { data, silent: true });
                const erro = res.data && res.data.erro;
                EventBus.$emit('show-alert', { tipo: erro ? 'error' : 'success', mensagem: res.data && res.data.mensagem });
                if (!erro) {
                    await this.carregar();
                    this.$emit('updated');
                }
            } catch (e) {
                EventBus.$emit('show-error', { error: e });
            } finally {
                this.salvando = false;
            }
        },
        validar(aprovado) {
            return this.executar(apiController.endpoints.validaRticketsuporte, {
                id_ticket: this.ticket.id_ticket,
                aprovado,
                motivo: aprovado ? null : this.motivoRejeicao
            });
        },
        encaminhar() {
            return this.executar(apiController.endpoints.encaminharticket, { id_ticket: this.ticket.id_ticket });
        }
    }
};
</script>
